import $ from 'jquery';
import 'slick-carousel';
import debounce from 'lodash/debounce';

$(document).ready(() => {
  initCarousel();
  $(window).resize(debounce(initCarousel, 50));
});

function initCarousel() {
  const $carousel = $('.js-36v-product-carousel');

  // If we've already initialised then don't re-slick
  if (!$carousel.length || $carousel.hasClass('slick-initialized')) { return; }

  // Only carousel on desktop
  if (matchMedia('(min-width: 768px)').matches) {
    $($carousel).slick({
      dots: false,
      arrows: true,
      pauseOnHover: true,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 1000,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 769,
          settings: 'unslick', // This will unslick itself on mobile
        },
      ],
    });
  }
}
